import { createSlice } from "@reduxjs/toolkit";
import {
  fetchJournals,
  fetchJournalCode,
  saveJournal,
  deleteJournal,
  fetchHeadAccs,
  fetchExistingJournalCodes
} from "./journalThunk";
import { currentDateTime } from "../../lib/functions";

const initialState = {
  entryDate: currentDateTime(),
  journalDate: currentDateTime(),
  list: [],
  journalCode: "",
  existingJournalCodes: null,
  headAccs: [],
  balances: {}, // supplier balances if needed  
  loading: false,
  error: null,
  selectedJournal: null,
  isEditJournal: false,
  refreshList: false,
};

const journalSlice = createSlice({
  name: "journals",
  initialState,
  reducers: {
    resetJournals: () => initialState,
    setJournalCode: (state, action) => {
      state.journalCode = action.payload;
    },
    setEntryDate(state, action) {
      state.entryDate = action.payload;
    },
    setJournalDate(state, action) {
      state.journalDate = action.payload;
    },
    setSelectedJournal(state, action) {
      state.selectedJournal = action.payload;
    },
    setIsEditJournal(state, action) {
      state.isEditJournal = action.payload;
    },
    setRefreshList(state, action) {
      state.refreshList = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchJournals.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchJournals.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload || [];
      })
      .addCase(fetchJournals.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchJournalCode.fulfilled, (state, action) => {
        state.journalCode = action.payload;
      })
      .addCase(fetchHeadAccs.fulfilled, (state, action) => {
        state.headAccs = action.payload;
      })
      .addCase(saveJournal.fulfilled, (state) => {
        state.refreshList = true;
      })
      .addCase(deleteJournal.fulfilled, (state, action) => {
        state.list = state.list.filter((e) => e.jrn_id !== action.payload.id);
      })
      .addCase(fetchExistingJournalCodes.fulfilled, (state, action) => {
        state.existingJournalCodes =  action.payload;
      });
  },
});

export const {
  resetJournals,
  setJournalCode,
  setEntryDate,
  setJournalDate,
  setSelectedJournal,
  setIsEditJournal,
  setRefreshList,
} = journalSlice.actions;

export default journalSlice.reducer;
